/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_BOX } from "../graphql/createBox.mutation";
import { CREATE_ORDER } from "../graphql/createOrder.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { CHECK_PAYMENT_FROM_FAC } from "../graphql/checkoutFAC.mutation";
import { GET_CURRENCY_EXCHANGE_RATE } from "../graphql/getCurrencyExchangeRate.query";
import { REGISTER_PAYMENT } from "../graphql/registerPayment.mutation";
import { REGISTER_FISERV_PAYMENT } from "../graphql/registerFiservPayment.mutation";
import { handleFormPaymentResponse } from "../../../utils/formPayment.util";

const is = require("is_js");
export interface ICreateBoxArgs {
  presentationID: string;
  sectionID: string;
  email: string;
  name: string;
  mode: string;
  price: any;
  currency: string;
  platformFee?: number;
  items: {
    costumeType: string;
    costumeFeature: string;
    costumeAttribute: string;
    costumeValue: string;
  }[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateBoxTypeMethods extends IPluginMethodMap {
  createBox(args: any): Promise<any>;
}

export class CreateBoxService implements IAgentPlugin {
  readonly methods: ICreateBoxTypeMethods;

  constructor() {
    this.methods = {
      createBox: this.createBox.bind(this),
    };
  }

  async createBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageService = StorageModule.getInstance();
    console.log("57print", args);
    let variables: any = {
      data: {
        presentation: args?.presentationID,
        section: args?.sectionID,
        items: args?.items,
        referal: args?.refId,
      },
    };
    if (args?.address) {
      variables.data["address"] = args?.address;
    }
    if (args?.delivery) {
      variables.data["delivery"] = { isOpted: args?.delivery?.isOpted };
    } else {
      variables.data["delivery"] = { isOpted: false };
    }
    if (args?.availableTime) {
      variables.data["availableTime"] = args?.availableTime;
    }
    if (args?.code) {
      variables = {
        ...variables,
        discountCode: args?.code,
      };
    }
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_BOX,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        const _res = await client.query({
          query: GET_CURRENCY_EXCHANGE_RATE,
          fetchPolicy: "network-only",
        });

        if (_res?.data?.getCurrencyExchangeRate) {
          storageService.set(
            "currencyExchangeLocal",
            _res?.data?.getCurrencyExchangeRate,
            "local"
          );
          storageService.set(
            "currencyExchangeSession",
            _res?.data?.getCurrencyExchangeRate,
            "session"
          );
        }
        console.log(res?.data?.createBox, is.existy(res?.data?.createBox));
        if (res?.data?.createBox && is.existy(res?.data?.createBox)) {
          console.log("hii");
          if (args?.mode === "online") {
            if (
              storageService.get("currencyExchangeLocal", "local")?.provider ===
              "FAC"
            ) {
              let variables: any = {
                data: {
                  cardDetail: {
                    cardExp: args?.expiry,
                    cardHolderName: args?.name,
                    cardPan: args?.number,
                    cvv: args?.cvc,
                  },
                  currency: args?.currency,
                  // tax: uuidv4(),
                  totalAmount: parseFloat(args?.amount),
                  payOrder: res?.data?.createBox?.payOrder?.id,
                  platformFee: args?.platformFee
                    ? parseFloat(args?.platformFee as any)
                    : 0,
                  allocations: (args?.allocations ?? []).filter(
                    (alloc: any) =>
                      alloc?.costumeValueId &&
                      Number(alloc?.amount || 0) > 0 &&
                      !alloc?.isPaid
                  ),
                },
              };
              if (args?.myEmail) {
                variables = {
                  ...variables,
                  data: {
                    ...variables?.data,
                    email: args?.myEmail,
                  },
                };
              }
              if (args?.phone) {
                variables = {
                  ...variables,
                  data: {
                    ...variables?.data,
                    phoneNumber: args?.event?.phone,
                  },
                };
              }
              console.log(variables);
              const resfac = await client.mutate({
                mutation: CHECK_PAYMENT_FROM_FAC,
                variables: variables,
                fetchPolicy: "no-cache",
              });

              if (is.existy(resfac?.data?.createCheckoutFAC?.RedirectData)) {
                document.write(resfac?.data?.createCheckoutFAC?.RedirectData);
                // window.location.href = output;
                return resfac?.data?.createCheckoutFAC;
              } else if (args?.code) {
                return res?.data?.createBox;
              } else {
                throw new Error("Some Error Occurred");
              }
            }
            const provider = storageService.get(
              "currencyExchangeLocal",
              "local"
            )?.provider;

            if (provider === "FISERV") {
              const gatewayCurrency =
                _res?.data?.getCurrencyExchangeRate?.currency ||
                storageService.get("currencyExchangeLocal", "local")
                  ?.currency ||
                "TTD";
              const conversionRate =
                _res?.data?.getCurrencyExchangeRate?.conversion_rate ||
                storageService.get("currencyExchangeLocal", "local")
                  ?.conversion_rate ||
                1;
              const rawPrice = args?.amount
                ? parseFloat(args?.amount)
                : args?.price
                ? parseFloat(args?.price)
                : 0;
              const userCurrency = args?.currency || "TTD";

              let calculatedAmount = rawPrice;
              if (
                args?.totalAmountPaid !== undefined &&
                Number(args.totalAmountPaid) > 0
              ) {
                calculatedAmount =
                  userCurrency === "USD"
                    ? Number(
                        (Number(args.totalAmountPaid) / conversionRate).toFixed(
                          2
                        )
                      )
                    : Number(Number(args.totalAmountPaid).toFixed(2));
              } else if (userCurrency === "USD" && rawPrice > 0) {
                calculatedAmount = rawPrice;
              }

              const costumeId =
                res?.data?.createBox?.costume?.id ||
                res?.data?.createBox?.payOrder?.costume?.id ||
                args?.costumeId ||
                "";
              const costumeValueId =
                args?.items?.[0]?.costumeValue ||
                args?.allocations?.[0]?.costumeValueId ||
                "";

              let fiservPlatformFee =
                args?.platformFee !== undefined
                  ? Number(args.platformFee)
                  : undefined;
              if (userCurrency === "USD" && fiservPlatformFee !== undefined) {
                if (
                  fiservPlatformFee > 10 &&
                  fiservPlatformFee > calculatedAmount * 0.1
                ) {
                  fiservPlatformFee = Number(
                    (fiservPlatformFee / conversionRate).toFixed(2)
                  );
                } else {
                  fiservPlatformFee = Number(fiservPlatformFee.toFixed(2));
                }
              } else if (fiservPlatformFee !== undefined) {
                fiservPlatformFee = Number(fiservPlatformFee.toFixed(2));
              }

              const fiservVariables: any = {
                data: {
                  amount: calculatedAmount,
                  //fix: support ttd
                  currency: userCurrency,
                  // currency: "USD",
                  enable3DS: true,
                  splitMap: [
                    {
                      payOrder: res?.data?.createBox?.payOrder?.id,
                      costumeId: costumeId,
                      amount: calculatedAmount,
                      allocations:
                        args?.allocations && args?.allocations.length > 0
                          ? args?.allocations
                              .map((alloc: any) => ({
                                costumeValueId:
                                  alloc?.costumeValueId || costumeValueId,
                                amount:
                                  alloc?.amount ??
                                  args?.totalAmountPaid ??
                                  rawPrice,
                                isPaid: alloc?.isPaid,
                              }))
                              .filter(
                                (alloc: any) =>
                                  Number(alloc?.amount || 0) > 0 &&
                                  !alloc?.isPaid
                              )
                              .map(({ costumeValueId, amount }: any) => ({
                                costumeValueId,
                                amount,
                              }))
                          : (args?.totalAmountPaid || rawPrice) > 0
                          ? [
                              {
                                costumeValueId: costumeValueId,
                                amount: args?.totalAmountPaid ?? rawPrice,
                              },
                            ]
                          : [],
                    },
                  ],
                  ...(fiservPlatformFee !== undefined && {
                    platformFee: fiservPlatformFee,
                  }),
                },
              };
              console.log("payload=======>", fiservVariables);
              const resFiserv = await client.mutate({
                mutation: REGISTER_FISERV_PAYMENT,
                variables: fiservVariables,
                fetchPolicy: "no-cache",
              });
              console.log(resFiserv);
              const fiservPayRes = resFiserv?.data?.registerFiservPayment;
              if (fiservPayRes) {
                handleFormPaymentResponse(fiservPayRes);
                return {
                  submitted: true,
                  ...fiservPayRes,
                };
              }
            }

            if (provider === "CAL" || provider === "CALKIDS") {
              const calPlatformFee =
                args?.currency === "USD" && args?.platformFee !== undefined
                  ? args.platformFee > 10 &&
                    args.platformFee >
                      Number(args?.amount || args?.price || 0) * 0.1
                    ? Number(
                        (Number(args.platformFee) / conversionRate).toFixed(2)
                      )
                    : args.platformFee
                  : args?.platformFee;

              let variables: any = {
                data: {
                  currency: args?.currency,
                  amount: calculatedAmount,
                  payorder: res?.data?.createBox?.payOrder?.id,
                  ...(calPlatformFee !== undefined && {
                    platformFee: calPlatformFee,
                  }),
                },
              };
              if (args?.code) {
                variables = {
                  ...variables,
                  discountCode: args?.code,
                };
              }
              console.log("variables", variables);
              const resCal = await client.mutate({
                mutation: REGISTER_PAYMENT,
                variables: variables,
                fetchPolicy: "no-cache",
              });

              if (is.existy(resCal?.data?.registerPayment)) {
                const paymentUrl =
                  resCal?.data?.registerPayment?.data?.session[
                    "payment-hosted-url"
                  ];
                if (paymentUrl) {
                  // Redirect to the payment URL
                  window.location.href = paymentUrl;
                  console.log(`Redirecting to: ${paymentUrl}`);
                  return {
                    ...resCal?.data?.registerPayment,
                    redirection: true,
                  };
                }
                return {
                  ...resCal?.data?.registerPayment,
                  redirection: false,
                };
              } else if (args?.code) {
                return res?.data?.createBox;
              } else {
                throw new Error("Some Error Occurred");
              }
            } else {
              let variable: any = {
                data: {
                  name: args?.name,
                  email: args?.email,
                  payOrder: res?.data?.createBox?.payOrder?.id,
                  price: args?.amount
                    ? parseFloat(args?.amount)
                    : args?.price
                    ? parseFloat(args?.price)
                    : 0,
                  currency: args?.currency,
                  // TEMP: Platform Fee disabled until backend deployment
                  platformFee: args?.platformFee
                    ? parseFloat(args?.platformFee as any)
                    : 0,
                },
              };
              // if (args?.code) {
              //   variable = { ...variable, discountCode: args?.code }
              // }
              const orderRes = await client.mutate({
                mutation: CREATE_ORDER,
                variables: variable,
                fetchPolicy: "no-cache",
              });
              const paymentRes = orderRes?.data?.getAnglPayRedirectURL;
              if (is.existy(paymentRes?.redirectUrl)) {
                const output = paymentRes?.redirectUrl;
                window.location.href = output;

                return paymentRes;
              } else if (paymentRes?.htmlCode || paymentRes?.formAction) {
                handleFormPaymentResponse(paymentRes);
                return {
                  submitted: true,
                  ...paymentRes,
                };
              } else if (
                is.existy(orderRes?.data?.getAnglPayRedirectURL?.token) ||
                is.existy(
                  orderRes?.data?.getAnglPayRedirectURL?.captureContext
                ) ||
                is.existy(
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId?.token
                )
              ) {
                const token =
                  orderRes?.data?.getAnglPayRedirectURL?.token ||
                  orderRes?.data?.getAnglPayRedirectURL?.captureContext ||
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId?.token;
                const sessionId =
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId;
                return {
                  redirect: "cybersource",
                  token: token,
                  sessionId,
                  payOrder: res?.data?.createBox?.payOrder?.id,
                  data: {
                    price: args?.amount
                      ? parseFloat(args?.amount)
                      : args?.price
                      ? parseFloat(args?.price)
                      : 0,
                    platformFee: args?.platformFee
                      ? parseFloat(args?.platformFee as any)
                      : 0,
                    currency: args?.currency,
                    payOrder: res?.data?.createBox?.payOrder?.id,
                    ...(args?.allocations && {
                      allocations: args.allocations.filter(
                        (alloc: any) =>
                          alloc?.costumeValueId &&
                          Number(alloc?.amount || 0) > 0 &&
                          !alloc?.isPaid
                      ),
                    }),
                  },
                };
              } else if (
                is.existy(
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId?.sessionId
                )
              ) {
                const output =
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId?.sessionId;
                console.log(output);
                return {
                  redirect: "apv2",
                  sessionId: output,
                  platformFee: args?.platformFee,
                  data: {
                    price: args?.amount
                      ? parseFloat(args?.amount)
                      : args?.price
                      ? parseFloat(args?.price)
                      : 0,
                    currency: args?.currency,
                    payOrder: res?.data?.createBox?.payOrder?.id,
                    platformFee: args?.platformFee
                      ? parseFloat(args?.platformFee as any)
                      : 0,
                    ...(args?.allocations && {
                      allocations: args.allocations.filter(
                        (alloc: any) =>
                          alloc?.costumeValueId &&
                          Number(alloc?.amount || 0) > 0 &&
                          !alloc?.isPaid
                      ),
                    }),
                  },
                };
              } else {
                throw new Error("Some Error Occurred");
              }
            }
          } else {
            // Success feedback is shown via ShopUpsellHost modal on Orders
            return res?.data?.createBox;
          }
        } else {
          return res?.data?.createBox;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find(
          (item: any) => item?.extensions?.display_message
        )?.extensions?.display_message;

      const errorMessage =
        _display_message ||
        err?.graphQLErrors?.[0]?.message ||
        err?.networkError?.message ||
        err?.message ||
        "Some unexpected error occurred";

      throw Error(errorMessage);
    }
  }
}
